import { useState } from 'react';

const Contact = () => {
  return (
    <section className="py-20 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Contactez-nous
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Transformons ensemble votre vision en une expérience culinaire inoubliable
          </p>
        </div>

        {/* Section principale */}
        <div className="grid lg:grid-cols-3 gap-12">
          {/* Colonne 1: Informations de contact */}
          <div className="lg:col-span-1">
            <div className="bg-gray-900 p-8 rounded-2xl h-full">
              <h3 className="text-2xl font-bold text-white mb-8">Nos coordonnées</h3>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-phone-line text-gray-400 text-xl"></i>
                  </div>
                  <div>
                    <p className="text-white font-semibold">Téléphone</p>
                    <a href="tel:0606827990" className="text-gray-300 hover:text-white transition-colors">
                      06 06 82 79 90
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-mail-line text-gray-400 text-xl"></i>
                  </div>
                  <div>
                    <p className="text-white font-semibold">Email</p>
                    <a href="mailto:gmoulinvert@gmail.com" className="text-gray-300 hover:text-white transition-colors">
                      gmoulinvert@gmail.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-map-pin-line text-gray-400 text-xl"></i>
                  </div>
                  <div>
                    <p className="text-white font-semibold">Zone d'intervention</p>
                    <p className="text-gray-300">Paris et Île-de-France</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-time-line text-gray-400 text-xl"></i>
                  </div>
                  <div>
                    <p className="text-white font-semibold">Horaires</p>
                    <p className="text-gray-300">Lun-Ven: 9h-18h</p>
                    <p className="text-gray-300">Sam: 9h-16h</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Colonne 2: Appel à l'action principal */}
          <div className="lg:col-span-1">
            <div className="bg-gradient-to-br from-gray-800 to-gray-900 p-8 rounded-2xl text-center h-full flex flex-col justify-center">
              <div className="mb-6">
                <i className="ri-phone-line text-6xl text-gray-400 mb-4"></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">Contactez-nous directement</h3>
              <p className="text-gray-300 mb-8">Appelez-nous pour discuter de votre projet et obtenir un devis personnalisé</p>
              <a 
                href="tel:0606827990" 
                className="inline-flex items-center justify-center space-x-2 bg-gradient-to-r from-gray-600 to-gray-400 text-black px-8 py-4 rounded-lg font-semibold hover:from-gray-500 hover:to-gray-300 transition-all duration-300 whitespace-nowrap cursor-pointer transform hover:scale-105"
              >
                <i className="ri-phone-line text-xl"></i>
                <span>06 06 82 79 90</span>
              </a>
            </div>
          </div>

          {/* Colonne 3: Avantages */}
          <div className="lg:col-span-1">
            <div className="bg-gray-900 p-8 rounded-2xl h-full">
              <h3 className="text-2xl font-bold text-white mb-8">Pourquoi nous choisir ?</h3>
              <ul className="space-y-6">
                <li className="flex items-start space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center mt-1">
                    <i className="ri-check-line text-gray-400 text-xl"></i>
                  </div>
                  <div>
                    <p className="text-white font-semibold">Devis gratuit</p>
                    <p className="text-gray-300 text-sm">Réponse sous 24h</p>
                  </div>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center mt-1">
                    <i className="ri-check-line text-gray-400 text-xl"></i>
                  </div>
                  <div>
                    <p className="text-white font-semibold">Équipe expérimentée</p>
                    <p className="text-gray-300 text-sm">Chefs professionnels</p>
                  </div>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center mt-1">
                    <i className="ri-check-line text-gray-400 text-xl"></i>
                  </div>
                  <div>
                    <p className="text-white font-semibold">Produits frais</p>
                    <p className="text-gray-300 text-sm">Ingrédients de saison</p>
                  </div>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center mt-1">
                    <i className="ri-check-line text-gray-400 text-xl"></i>
                  </div>
                  <div>
                    <p className="text-white font-semibold">Service personnalisé</p>
                    <p className="text-gray-300 text-sm">Adapté à vos besoins</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Footer supprimé */}
      </div>
    </section>
  );
};

export default Contact;
